import axios from "axios";

export const loginWithOtp = async (otp, mobile, otp_id) => {
  try {
    const payload = otp_id ? { otp, mobile: null, otp_id } : { otp, mobile };
    const response = await axios.post(
      `${process.env.REACT_APP_BASEURL}/api/user/otpverify`,
      payload
    );
    return response.data;
  } catch (err) {
    return {
      "success": false,
      "message": err?.response?.data?.message,
      "attemptsLeft": err?.response?.data?.attemptsLeft
    }
  }
};
